<ion-header
  class="ion-no-border"
  [ngClass]="
    platform !== platformRef.desktop
      ? platform === platformRef?.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar *ngIf="platform === platformRef.desktop">
    <ion-buttons slot="end">
      <ion-button
        id="close-modal-btn"
        data-cy="close-delete-list-summary-modal-button"
        (click)="cancel()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content
  scroll-y="false"
  [class.mobile-content]="platform === platformRef.mobile"
>
  <div class="summary-container">
    <div data-cy="delete-list-summary-title-container" class="title">
      <ion-label class="bold" data-cy="delete-list-summary-title">
        {{ title }}</ion-label
      >
    </div>
    <ion-list>
      <ion-item-divider></ion-item-divider>
      <ion-item *ngFor="let customer of customerList; let i = index">
        <div class="customer-info">
          <span data-cy="index">{{ i + 1 }}</span>
          <div class="customer-name-number-departments">
            <span data-cy="customer-name-number" class="bold"
              >{{ customer?.customerName }} ({{
                customer?.customerNumber
              }})</span
            >
            <span
              class="departments"
              data-cy="customer-department"
              *ngFor="let department of customer?.departments"
            >
              {{ department }}
            </span>
          </div>
        </div>
      </ion-item>
    </ion-list>
  </div>
</ion-content>

<ion-footer class="ion-footer-modal" mode="md">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        data-cy="delete-list-cancel-modal-button"
        [ngClass]="
          platform !== platformRef?.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        (click)="cancel()"
      >
        {{
          (isConfirmation ? 'i18n.common.goBack' : 'i18n.common.cancel')
            | translate
            | titlecase
        }}
      </ion-button>
      <ion-button
        *ngIf="isConfirmation"
        data-cy="delete-list-confirm-modal-button"
        [ngClass]="
          platform !== platformRef.mobile
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-green-mobile-modal-button'
        "
        (click)="delete()"
      >
        {{ 'i18n.common.delete' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
